"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const type_1 = require("../../../type");
const Field_Constant_1 = require("../utils/Field.Constant");
const FieldCheckBox = ({ props }) => {
    var _a;
    const [value, setValue] = React.useState(props.options.map((option) => {
        return { option: option, checked: false };
    }));
    React.useEffect(() => {
        props.setValue(value);
    }, [value]);
    const isDisabled = typeof props.disabled === type_1.TYPE_FUNCTION
        ? props.disabled(props)
        : props.disabled;
    return (React.createElement("div", { style: {
            display: props.direction === "vertical" ? "flex" : "grid",
        }, className: `${Field_Constant_1.TEXT_AUTHOR}-wrapper ${typeof props.classNameWrapper === type_1.TYPE_FUNCTION
            ? props.classNameWrapper(props)
            : props.classNameWrapper}` }, (_a = props === null || props === void 0 ? void 0 : props.options) === null || _a === void 0 ? void 0 : _a.map((option, index) => {
        return (React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-options ${typeof props.classNameOptions === type_1.TYPE_FUNCTION
                ? props.classNameOptions(props)
                : props.classNameOptions}`, style: {
                display: "flex",
            } },
            React.createElement("input", { style: {
                    marginTop: "auto",
                    marginBottom: "auto",
                    marginRight: "8px",
                }, id: props.name, disabled: isDisabled, type: "checkbox", key: `key-checkbox-${index}`, className: `${Field_Constant_1.TEXT_AUTHOR}-input ${typeof props.classNameInput === type_1.TYPE_FUNCTION
                    ? props.classNameInput(props)
                    : props.classNameInput}`, checked: value[index].checked === true, name: props.name, onClick: () => {
                    setValue((prev) => {
                        let newValue = [...prev];
                        newValue[index].checked = !newValue[index].checked;
                        return [...newValue];
                    });
                } }),
            React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-option ${typeof props.classNameOption === type_1.TYPE_FUNCTION
                    ? props.classNameOption(props)
                    : props.classNameOption}` }, option)));
    })));
};
exports.default = FieldCheckBox;
